// src/components/blog/BlogRedirect.jsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BlogRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Log the 404 attempt for analytics
        console.log(`404 - Page not found: ${location.pathname}`);

        // You can send this to your analytics
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'page_not_found', {
                page_path: location.pathname,
                page_title: '404 - Page Not Found'
            });
        }

        // Redirect to blog page after a short delay
        const timer = setTimeout(() => {
            navigate('/blog', {
                state: {
                    from: location.pathname,
                    message: "The page you're looking for doesn't exist. Redirecting to our blog..."
                }
            });
        }, 1000);

        return () => clearTimeout(timer);
    }, [location, navigate]);

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h1 style={styles.title}>404 - Page Not Found</h1>
                <p style={styles.message}>
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <p style={styles.redirect}>
                    Redirecting you to our blog in 2 seconds...
                </p>
                <div style={styles.spinner}></div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    content: {
        textAlign: 'center',
        padding: '2rem',
        background: 'white',
        borderRadius: '1rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        margin: '0 1rem',
    },
    title: {
        fontSize: '2rem',
        color: '#333',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1.1rem',
        color: '#666',
        marginBottom: '1rem',
        lineHeight: 1.6,
    },
    redirect: {
        fontSize: '1rem',
        color: '#888',
        marginBottom: '2rem',
    },
    spinner: {
        width: '40px',
        height: '40px',
        margin: '0 auto',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #764ba2',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    },
};

// Add keyframes for spinner
if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    document.head.appendChild(style);
}

export default BlogRedirect;